export const deepFind = (obj: object = {}, path: string) => {
  const paths = path.split('.');
  if (paths.length === 1) {
    return obj[paths[0]];
  }
  return deepFind(obj[paths[0]], paths.slice(1).join('.'));
};
